<template>
   <q-layout view="lhh LpR lff">
    <q-page-container>
      <q-page padding ref="qPage">
        <div class="row justify-between">
          <q-btn class="q-ma-xs q-pr-md justify-left" ripple dense flat color="black" to="/">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
          <!-- <div class="col text-right row justify-end"> -->
            
          <!-- </div> -->
        </div>
            <div class="text-h5 text-center q-py-md">Nhật ký thực hiện công việc</div>
        <q-card class="row q-my-xs">
          <div class="col-xs-12 col-sm-4 q-pa-md">
            <div class="row justify-between">
              <q-input class="col-11" flat readonly v-model="filterDate">
                <template v-slot:append>
                </template>
              </q-input>
              <q-icon name="event" class="cursor-pointer col-1 self-center" size="32px">
                <q-popup-proxy d ref="qDateProxy" transition-show="scale" transition-hide="scale">
                  <q-date flat v-model="filterDate" mask="DD/MM/YYYY" minimal @input="() => $refs.qDateProxy.hide()" />
                </q-popup-proxy>
              </q-icon>
            </div>
          </div>
          <div class="col-xs-12 col-sm-8 col-lg-8 q-pa-md row">
            <q-select
            class="col-xs-12 col-sm-4 q-mx-xs"
            ref = "farm"
            name = "farm"
            clearable
            emit-value v-model="farm" :options="farms" option-value="id" option-label="name" :display-value="$getNameById(farmStore.list, farm, 'name')" label="Nông trường" >
              <template v-slot:prepend>
                <q-icon name="filter_vintage" />
              </template>
            </q-select>
            <q-select class="col-xs-12 col-sm-4 q-mx-xs"
                clearable
                emit-value v-model="jobCategory" :options="jobStore.categories" option-value="id" option-label="name" :display-value="$getNameById(jobStore.categories, jobCategory, 'name')" label="Loại công việc">
                <template v-slot:prepend>
                  <q-icon name="fas fa-bars" />
                </template>
              </q-select>
            <q-btn class="col-1" ripple icon="cloud_upload" flat color="black" size="20px" to="/tasks/upload" />
            <q-btn class="col-1" ripple icon="cloud_download" flat color="black" size="20px" @click="download" :loading="load"/>
          </div>
        </q-card>

        <q-ajax-bar ref="bar" position="top" color="red-4" size="3px" skip-hijack></q-ajax-bar>
        <q-table
          :data="tasksData"
          :columns="headers"
          row-key="name"
          no-data-label="Không có dữ liệu"
          :key="tableKey"
          :loading="load"
          :pagination.sync= pagination
          :hide-bottom="!_.isEmpty(tasksData)"
          >
          <template v-slot:body ="props">
            <q-tr :props="props" v-if="!props.row.deleted">
              <q-td @click.native="routeTaskData(props.row._id)" class="label-xs-right text-center">{{ props.row.__index+1 }}</q-td>
              <q-td @click.native="routeTaskData(props.row._id)" v-if="props.colsMap.date" class="label-xs-right text-center">{{props.row.date instanceof firebase().firestore.Timestamp === true ? moment((props.row.date).toDate()).format(defaultDateFormat): props.row.date }}</q-td>
              <q-td @click.native="routeTaskData(props.row._id)" v-if="props.colsMap.farm" class="label-xs-right text-center">{{ $getNameById(farmStore.list, props.row.farm ,'name') }}</q-td>
              <q-td @click.native="routeTaskData(props.row._id)" v-if="props.colsMap.lot" class="label-xs-right text-center">{{ props.row.lot}}</q-td>
              <q-td @click.native="routeTaskData(props.row._id)" v-if="props.colsMap.job" class="label-xs-right text-center">{{ $getNameById(jobStore.list, props.row.job ,'name')}}</q-td>
              <q-td @click.native="routeTaskData(props.row._id)" v-if="props.colsMap.jobCategory" class="label-xs-right text-center">{{props.row.job ? $getNameById(jobStore.categories, $getNameById(jobStore.list, props.row.job, 'jobCategory'), 'name') : ''}}</q-td>
              <q-td @click.native="routeTaskData(props.row._id)" v-if="props.colsMap.totalWeight" class="label-xs-right text-center">{{ props.row.totalWeight > 0 ? props.row.totalWeight.toFixed(2) : 0 }}</q-td>
              <q-td @click.native="routeTaskData(props.row._id)" v-if="props.colsMap.unit" class="label-xs-right text-center">{{props.row.job ? $getNameById(jobStore.list, props.row.job ,'unit') : ''}}</q-td>
              <q-td @click.native="routeTaskData(props.row._id)" v-if="props.colsMap.type" class="label-xs-right text-center">{{ (props.row.worker && props.row.worker.type) ? $getNameById(workerTypes, props.row.worker.type,'label') : ''}}</q-td>
              <q-td @click.native="routeTaskData(props.row._id)" v-if="props.colsMap.number" class="label-xs-right text-center">{{ props.row.worker.number}}</q-td>
              <q-td @click.native="routeTaskData(props.row._id)" v-if="props.colsMap.meka" class="label-xs-right text-center">{{ (props.row.worker && props.row.worker.meka) ? $getNameById(mekaStore.list, props.row.worker.meka ,'displayName') : ''}}</q-td>
              <q-td @click.native="routeTaskData(props.row._id)" v-if="props.colsMap.supervisor" class="label-xs-right text-center">{{ props.row.supervisor }}</q-td>
              <q-td class="label-xs-right text-center" @click.native="clickDeleteButton(props)" >
                <q-btn ripple flat round color="black" icon="delete" :loading="load"/>
              </q-td>
            </q-tr>
          </template>
        </q-table>
        <!-- Float add button -->
        <q-page-sticky class="q-ma-md item-center" :style="'right:unset; left: '+ ($q.screen.width/2 - 45) + 'px'">
          <q-btn fab icon="add" color="green" @click="routeTaskData(null,'CREATE')"/>
        </q-page-sticky>
        <!-- Delete Record -->
        <q-dialog v-model="deleteDialog" persistent>
          <q-card>
            <q-card-section class="row items-center">
              <q-avatar icon="delete" color="black" text-color="white"/>
              <span class="q-ml-sm">Bạn có chắc chắn muốn xóa ?</span>
            </q-card-section>
            <q-card-actions align="right">
              <q-btn ripple flat icon="clear" v-close-popup/>
              <q-btn ripple flat icon="done"  v-close-popup @click="deleteItem()"/>
            </q-card-actions>
          </q-card>
        </q-dialog>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
/* eslint-disable no-unused-vars */
import moment from "moment"
import { mapGetters } from 'vuex'
import firebase from '@firebase/app'
import XLSX from 'xlsx'
const { Timestamp } = firebase.firestore
const XlsxPopulate = require('xlsx-populate')

export default {
  props: {
    rootModel: Object,
  },
  data() {
    return {
      acceptFileType: [
        '.xls',
        '.xlsx',
        '.csv',
      ],
      dialogUpload: true,
      pagination: {
        rowsPerPage: 0,
      },
      collection: "Tasks",
      tasks: null,
      taskId: null,
      farm: null,
      lot: null,
      farms: null,
      jobs: null,
      jobCategory: null,
      // lots: null,
      tableKey: 0,
      deleteDialog: false,
      load: false,
      selectedRowIndex: null,
      defaultDateFormat: 'DD/MM/YYYY',
      filterDate: moment.utc().format('DD/MM/YYYY'),
      workerTypes: [
        {
          label: 'Công nhật',
          value: 'congnhat',
          id: 'congnhat'
        },
        {
          label: 'Công khoán',
          value: 'khoan',
          id: 'khoan'
        }
      ],
      headers: [{
        label: "No",
        align: "center",
        name: "no",
        },
        {
        label: "Ngày",
        align: "center",
        name: "date",
        field: 'date',
        sortable: true,
        },
        {
        label: "Nông trường",
        align: "center",
        name: "farm",
        },
        // {
        // label: "Lô",
        // align: "center",
        // name: "lot",
        // },
        {
        label: "Nội dung CV",
        align: "center",
        name: "job",
        },
        {
        label: "Loại CV",
        align: "center",
        name: "jobCategory",
        },
        {
        label: "Khối lượng",
        align: "center",
        name: "totalWeight",
        },
        {
        label: "Đơn vị tính",
        align: "center",
        name: "unit",
        },
        {
        label: "Loại nhân công",
        align: "center",
        name: "type",
        },
        {
        label: "Số lượng",
        align: "center",
        name: "number",
        },
        {
        label: "Nhân công",
        align: "center",
        name: "meka",
        },
        {
        label: "Giám sát",
        align: "center",
        name: "supervisor",
        }
      ],
      csvFields: [
        {
        label: 'STT',
        },
        {
        label: 'Ngày',
        value: 'date',
        },
        {
        label: 'Giám sát',
        value: 'supervisor',
        },
        {
        label: 'Nông trường',
        value: 'farm'
        },
        // {
        // label: 'Lô',
        // value: 'lotID',
        // key: 'lotID',
        // type: 'number',
        // required: true
        // },
        // {
        // label: 'Ô',
        // value: 'slots',
        // key: 'slots',
        // type: 'array',
        // },
        {
        label: 'Mã CV',
        value: 'job',
        key: 'jobID',
        required: true,
        type: {
          showLabel: 'jobCode',
          listToFind: 'vm.jobStore.list'
          }
        },
        {
        label: 'Hạng mục công việc',
        value: 'job',
        },
        {
        label: 'Loại',
        value: 'worker.type',
        key: 'jobType',
        required: true,
        type: {
          showLabel: 'jobType',
          listToFind: 'vm.workerTypes'
          }
        },
        {
        label: 'Số lượng',
        value: 'worker.number',
        key: 'jobType',
        required: true,
        },
        // {
        // label: 'Định mức (Công/ngày)',
        // value: 'quotaTask',
        // key: 'quotaTask',
        // type: 'number',
        // required: true
        // },
        {
        label: 'Khối lượng',
        value: 'totalWeight',
        key: 'totalWeight',
        type: 'number',
        required: true
        },
        {
        label: 'Nhân công',
        value: 'worker.meka',
        key: 'meka',
        required: true,
        type: {
          showLabel: 'displayName',
          listToFind: 'vm.mekaStore.list'
          }
        },
        {
        label: 'ĐVT',
        value: 'unit',
        },
      ],
      dialogEdit: false,
      curUser: '',
      optionstasks: [],
    }
  },
  created() {
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    tasksData() {
      let data = this.tasks ? this.tasks.filter(v => 
      (this.farm ? this._.isEqual(v.farm,this.farm) : true) &&
      (this.lot ? this._.isEqual(v.lot,this.lot) : true ) &&
      (this.jobCategory ? this._.isEqual(v.jobCategory, this.jobCategory) : true )
      ) : []
      return data
    },
    lotOptions() {
      // eslint-disable-next-line
      this.lot = null
      return this.farm ? this.$getNameById(this.farmStore.list, this.farm ,'listLot') : []
    },
    ...mapGetters([
      'user',
      'permission',
      'isAnonymous',
      'farmStore',
      'mekaStore',
      'jobStore'
    ])
  },
  watch: {
    filterDate() {
      this.fetchData()
    }
  },
  methods: {
    async fetchData () {
      let vm = this
      vm.load = true
      vm.tasks = null
      let rp = vm.queryBuilder()
      let f = this.farmStore
      let j = this.jobStore
      Promise.all([rp, f, j]).then(res => {
        vm.tasks = res ? res[0] : []
        vm.tasks.sort((a, b) => a.date.toDate() < b.date.toDate() ? 1 : a.date.toDate() === a.date.toDate() ? 0 : -1)
        vm.farms = res && res[1] && res[1].list ? res[1].list : []
        vm.jobs = res && res[2] && res[2].list ? res[2].list : []
        vm.curUser = vm.curUser ? '' : vm.$store.getters.user.email
        vm.load = false
      })
    },
    queryBuilder() {
      const regexFarm = /(^F[0-9]M$)/
      let roles = this.permission.roles
      return this.$query([this.collection], [['date', '==', Timestamp.fromDate(moment.utc(this.filterDate, 'DD/MM/YYYY').toDate())],['deleted','==', false]]).then(data => {
        if(roles && roles.hasOwnProperty('BOM')) {
          return data.data
        } else {
          let fm = Object.keys(roles).filter((item) => regexFarm.test(item)).map(i => parseInt(i[1]))
          let filter = []
          data.data.forEach(item => {
            if(item.supervisor === this.user.email || fm.indexOf(item.farm) !== -1) {
              filter.push(item)
            }
          })
        return filter
        }
      })
    },
    download() {
      let vm = this
      let model= []

      //fields that need to convert
      let idFields = [
        {
          key:'date',
          name: 'date'
        },
        {
          key:'supervisor',
          name: 'supervisor',
        },
        {
          key:'farm',
          label:'name',
          list: vm.farms,
          name: 'farm'
        },
        // {
        //   key:'farm',
        //   label:'id',
        //   list: vm.farms,
        //   name: 'farmID'
        // },
        {
          key:'job',
          label:'jobCode',
          list: vm.jobs,
          name: 'jobCode'
        },
        {
          key:'job', //object['name'] = find in 'list', where 'key' return 'key'['label']
          label:'name',
          list: vm.jobs,
          name: 'job'
        },
        {
          key:'worker.type',
          label:'label',
          list: vm.workerTypes,
          name: 'type'
        },
        {
          key:'totalWeight',
          name: 'totalWeight',
        },
        {
          key:'worker.number',
           name: 'workerNumber'
        },
        {
          key:'worker.meka',
          label:'displayName',
          list: vm.mekaStore.list,
          name: 'meka'
        },
        {
          key:'job',
          label: 'unit',
          list: vm.jobs,
          name: 'unit'
        },
        ]

      //convert showing data to array
      //Plans worksheet
      model.push(vm._.map(vm.csvFields, 'label'))
      let secondModel = []
      if (!vm._.isEmpty(vm.tasks))
      {
        for (let i in vm.tasks) {
          //first value is no of line
          let row = [i]
          let field = {}
          let farm = vm.tasks[i] && vm.tasks[i].farm ? vm.tasks[i].farm : '' //for eval
          //add a row
          for (let f in idFields) {
            let value = vm._.get(vm.tasks[i], idFields[f].key)
            let list = idFields[f].list
            let name = idFields[f].value
            let label = idFields[f].label
  
            //if value is date type
            if (value instanceof Timestamp) {
              let date = moment((value).toDate()).format(this.defaultDateFormat)
              field[idFields[f].name] = date
              row.push(date)
            }
            else {
              field[idFields[f].name] = list ? vm.$getNameById(list, value, label) : (value instanceof Object) ? (JSON.stringify(value)).substr(1,JSON.stringify(value).length-2) : value
              row.push(field[idFields[f].name])
            }
          }
  
          //pushing details in to secondModel, workSheet
          let details = vm._.get(vm.tasks[i], 'details')
  
          vm._.forEach(details, value => {
            let childRow = vm._.cloneDeep(field)
            vm._.forEach(value, (childVal, childKey) => {
              childRow[childKey] = childVal
            })
            secondModel.push(childRow)
          })
            
          model.push(row)
        }
      }

      let col = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N']

      let colWidth = [
        [ //details sheet
        10,//stt
        20,//ngay
        30,//gs
        30,//nt
        20,// lo
        30,// ma cv
        40,// cv
        20,//dvt
        30,//loai
        15,// sl
        20,//kl
        20,//meka
        40,//note
        ],
        [
          10,
          40,
          50,
          20,
        ],
        [//nt
          10,
          30,
          30,
          10,
          20,
          20,
        ],
        [//meka
          10,
          20,
          20,
          20,
          30,
          30,
        ],
        [//sum
           10, //stt
          20,//ngay
          30, //gs
          30, //nt
          40,//ma cv
          40,//cv
          20,//loai
          20,//sl
          20,// kl
          20,//dvt
          20,//meka
          40,//note
        ]
      ]

      //Details worksheet
      let details = [['STT','Ngày', 'Giám sát', 'Nông trường', 'Lô','Mã CV','Hạng mục CV','Loại CV','Loại nhân công', 'Số lượng','Khối lượng','ĐVT','Nhân công','Ghi chú']]
      if (!vm._.isEmpty(secondModel))
      {
        for (let i in secondModel) {
          let row = [i]
          row.push(secondModel[i].date)
          row.push(secondModel[i].supervisor)
          row.push(secondModel[i].farm)
          row.push(vm.$getNameById(vm._.find(vm.farms,{name:secondModel[i].farm}).listLot,secondModel[i].lot, 'name')) //lot name
          row.push(secondModel[i].jobCode)
          row.push(vm._.find(vm.jobStore.list, {jobCode:secondModel[i].jobCode}).name)
          let jobCategory = vm._.find(vm.jobStore.list, {jobCode:secondModel[i].jobCode}).jobCategory
          row.push(vm.$getNameById(vm.jobStore.categories, jobCategory, 'name')) //job category
          row.push(vm._.find(vm.workerTypes,{label:secondModel[i].type}).label)
          row.push(secondModel[i].workerNumber)
          row.push(secondModel[i].weight)
          row.push(secondModel[i].unit)
          row.push(secondModel[i].meka)
          row.push(secondModel[i].note)
          details.push(row)
        }
      }

      //Jobs worksheet
      let jobs = [['STT','Mã CV','Hạng mục công việc','Đơn vị']]
      for (let i in vm.jobs) {
        let row = [i]
        row.push(vm.jobs[i].jobCode)
        row.push(vm.jobs[i].name)
        row.push(vm.jobs[i].unit)
        jobs.push(row)
      }

      //Farms worksheet
      let farmSheet = [['STT','Nông trường','Mã nông trường','Lô','Mã lô','Diện tích (Ha)']]
      for (let i in vm.farms) {
        let findLot = vm.farms[i].listLot
        vm._.forEach(findLot, (lot) => {
          let row = []
          row.push(farmSheet.length)
          row.push(vm.farms[i].name)
          row.push(vm.farms[i].farmCode)
          row.push(lot.name)
          row.push(lot.id)
          row.push(lot.area)
          row.push(vm.farms[i].unit)
        farmSheet.push(row)
        })
      }

      //Meka
      let mekaSheet = [['STT','Tên','Mã NV', 'Email', 'SĐT','Ghi Chú']]
      for (let i in vm.mekaStore.list) {
        let row  = [i]
        row.push(vm.mekaStore.list[i].displayName)
        row.push(vm.mekaStore.list[i].mekaId)
        row.push(vm.mekaStore.list[i].email)
        row.push(vm.mekaStore.list[i].mobile)
        row.push(vm.mekaStore.list[i].note)
        mekaSheet.push(row)
      }

      let ext = 'xlsx'
      //Generate a file name
      let fileName = moment.utc(this.filterDate, 'DD/MM/YYYY').format('DDMMYYYY')
      
      //generate workbook n worksheet

      XlsxPopulate.fromBlankAsync().then(workbook => {
          workbook.sheet(0).cell("A1").value(details)
          workbook.sheet(0).name('Chi tiết CV').row(1).style("bold", true)
          workbook.addSheet("DS công việc")
          workbook.sheet(1).cell("A1").value(jobs)
          workbook.sheet(1).name("DS công việc").row(1).style("bold", true)
          workbook.addSheet("DS nông trường")
          workbook.sheet(2).cell("A1").value(farmSheet)
          workbook.sheet(2).name("DS nông trường").row(1).style("bold", true)
          workbook.addSheet("DS nhân công")
          workbook.sheet(3).cell("A1").value(mekaSheet)
          workbook.sheet(3).name("DS nhân công").row(1).style("bold", true)
          workbook.addSheet(fileName)
          workbook.sheet(4).cell("A1").value(model)
          workbook.sheet(4).name(fileName).row(1).style("bold", true)
          for (let i in workbook.sheets()) {
            for (let j in colWidth[i]) {
              workbook.sheets()[i].column(col[j]).width(colWidth[i][j])
            }
          }
        return workbook.outputAsync()
        }).then(blob => {
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, `${fileName}.${ext}`)
          }
          else {
            var url = window.URL.createObjectURL(blob)
            var a = document.createElement("a")
            document.body.appendChild(a)
            a.href = url
            a.download = `${fileName}.${ext}`
            a.click()
            window.URL.revokeObjectURL(url)
            document.body.removeChild(a)
          }
        }).catch(err => {
          throw err
      })
    },
    routeTaskData(taskId, mode) {
      this.$router.push({
        name: '/tasks/entry',
        query: {
          id: taskId ? taskId : undefined,
        },
        params: {
          taskId: taskId,
          mode: mode ? mode : undefined
        }
      });
    },
    hasPermission(name) {
      let vm = this
      if (vm.permission && vm.permission[vm.$parent.route]) {
        return vm.permission[vm.$parent.route].all && vm.permission[vm.$parent.route].all.indexOf(name) >= 0
      }
      return false
    },
    clickDeleteButton(props) {
      this.selectedRowIndex = this._.findIndex(this.tasks, props.row)
      this.deleteDialog = true
    },
    async deleteItem() {
      let vm = this
      vm.deleteDialog = false
      vm.tableKey ++
      vm.load = true

      vm.$refs.bar.start()
      let dataSubmit = vm._.cloneDeep(vm.tasks[vm.selectedRowIndex])
      dataSubmit.deleted = true
      let submitModel = { id: vm.tasks[vm.selectedRowIndex]._id, data: dataSubmit}
      await vm.$command.execute('updateTask', submitModel).then(async () => {
        vm.$q.notify({
          message: 'Đã lưu thành công',
          color: 'black',
          icon: 'check'
        })
        await this.fetchData()
      },  { mode: 'no-cors'} ).catch((error) => {
        vm.$q.notify({
          message: `Xóa thất bại ${error}`,
          color: 'red',
          icon: 'error'
        })
      })
      vm.$refs.bar ? vm.$refs.bar.stop() : null
    },
    moment(timestamp) {
      return moment(timestamp)
    },
    firebase() {
      return firebase
    }
  }
}

</script>
